<template>
	<div class="main" :class="{dark}">
		<vHeader/>
		<div class="wrap">
			<slot/>
		</div>

		<lady/>
	</div>
</template>

<script>
import vHeader from "@/components/header/index.vue";
import lady from "@/components/lady.vue";

export default {
	components: {vHeader, lady},
	computed: {
		dark: (t) => t.$route.name === "profile"
	}
};
</script>

<style lang="scss" scoped>
.main {
	min-height: 100vh;
	padding-bottom: 4em;

	&.dark {
		background-color: #22313A;

		@include res(mobile) {
			background-color: transparent;
		}
	}

	@include res(mobile) {
		padding-bottom: 2em;
	}

	.wrap {
		padding-top: $header;

		@include res(small) {
			padding-top: $headerSmall;
		}
	}
}
</style>
